import { throttle, select, takeEvery } from 'redux-saga/effects';
import { get, set, remove, setSession, removeSession } from './storage';
import { LOGOUT, LOGIN_SUCCESS } from '../redux/auth';
import { CHECK_CHARITY_CODE, STRIPE_CHECKOUT } from '../redux/signup';

export function* persistSaga() {
    yield [
        throttle(2000, '*', saveInLocalStorage),
        takeEvery(STRIPE_CHECKOUT, moveToSessionStorage),
        takeEvery(CHECK_CHARITY_CODE, moveToSessionStorage),
        takeEvery(LOGIN_SUCCESS, clearSessionStorage),
        takeEvery(LOGOUT, clearStorage),
    ];
}

export function* clearStorage() {
    remove('state');
    yield null;
}

export function* clearSessionStorage() {
    removeSession('state');
    yield null;
}

export function* saveInLocalStorage() {
    const {
        workouts: { items, full },
        auth: { planId, runnerId, sessionKey, archived, freePlan: { modalSeen } },
        race: { info },
        preferences,
        profile,
        theme,
    } = yield select();
    set('state', {
        workouts: { items, full },
        auth: { planId, runnerId, sessionKey, archived, freePlan: { modalSeen } },
        race: { info },
        preferences: {
            form: preferences.form,
            values: preferences.values,
        },
        profile: {
            form: profile.form,
            values: profile.values,
        },
        theme,
    });
}

export function* moveToSessionStorage() {
    const {
        signup: { planId, runnerId, fields: { tweek } },
    } = yield select();
    setSession('state', {
        signup: { planId, runnerId, fields: { tweek } },
    });
}

export function loadState() {
    const state = get('state');
    return state || {};
}



/** WEBPACK FOOTER **
 ** ./src/utils/persist.js
 **/